import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { Input } from '@/components/ui/input'
import type { FieldOption } from '@escuela/ficha-domain'

interface PillSelectProps {
  options: readonly FieldOption[]
  /** Ids/valores seleccionados. */
  value: string[]
  onChange: (value: string[]) => void
  /** Texto libre "otros" (campo hermano). */
  otros: string
  onOtrosChange: (value: string) => void
  ariaLabel?: string
}

/**
 * Multi-choice equivalente al PillSelect de la app: chips que se togglean +
 * un input de texto libre "Otros".
 */
export function PillSelect({
  options,
  value,
  onChange,
  otros,
  onOtrosChange,
  ariaLabel,
}: PillSelectProps): ReactNode {
  const toggle = (v: string): void => {
    if (value.includes(v)) onChange(value.filter((x) => x !== v))
    else onChange([...value, v])
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap gap-2" role="group" aria-label={ariaLabel}>
        {options.map((opt) => {
          const active = value.includes(opt.value)
          return (
            <button
              key={opt.value}
              type="button"
              aria-pressed={active}
              onClick={() => toggle(opt.value)}
              className={cn(
                'rounded-full border px-3 py-1 text-sm transition-colors',
                active
                  ? 'border-primary bg-primary/10 text-primary'
                  : 'border-input bg-background text-foreground hover:bg-accent hover:text-accent-foreground',
              )}
            >
              {opt.label}
            </button>
          )
        })}
      </div>
      <Input
        value={otros}
        onChange={(e) => onOtrosChange(e.target.value)}
        placeholder="Otros (texto libre)"
      />
    </div>
  )
}
